import MenuGoBack from './MenuGoBack';

export default MenuGoBack;
